// cache name
var _cacheName = 'wappo';
var refreshing;

// base caching list
var _filesToCache = [

    '/',

    // css
    '/assets/dist/site.css',

    // js
    '/assets/dist/site.js',

    // img
    '/assets/shared/img/offline.gif'
];

/* ---------------------------------------------
/* SERVICE WORKER EVENTS
--------------------------------------------- */

// push notifications listener
self.addEventListener('push', function (event)
{
    let notificationData = event.data.json();

    event.waitUntil(
        self.registration.showNotification(

            // title
            notificationData.title,

            // options
            {
                // body
                body: notificationData.options.body,

                // icon
                icon: notificationData.options.icon,

                // badge
                badge: notificationData.options.badge,

                // custom data
                data: notificationData.options.data
            })
    );

});

// notification click
self.addEventListener('notificationclick', function (event)
{
    // close the notification
    event.notification.close();

    // see if the current is open and if it is focus it. Otherwise open new tab
    event.waitUntil(
        self.clients.matchAll().then(function (clientList)
        {
            // check: url exists
            if (event.notification.data.url !== '')
                return self.clients.openWindow(event.notification.data.url);
            else if (clientList.length > 0)
                return clientList[0].focus();
            else
                return false;
        })
    );
});

// notification close
self.addEventListener('notificationclose', function (e)
{

});

// install sw and cache
self.addEventListener("install", function (event)
{
    event.waitUntil(
        /* The caches built-in is a promise-based API that helps you cache responses,
            as well as finding and deleting them.
        */
        caches
            /* You can open a cache by name, and this method returns a promise. We use
                a versioned cache name here so that we can remove old cache entries in
                one fell swoop later, when phasing out an older service worker.
            */
            .open(_cacheName)
            .then(function (cache)
            {
                /* After the cache is opened, we can fill it with the offline fundamentals.
                    The method below will add all resources we've indicated to the cache,
                    after making HTTP requests for each of them.
                */
                return cache.addAll(_filesToCache);
            })
            .then(function ()
            {
                //console.log('WORKER: install completed');
            })
    );
});

// on activating
self.addEventListener('activate', function (event)
{
    event.waitUntil(
        caches.keys().then(function (cacheNames)
        {
            return Promise.all(
                cacheNames.filter(function (cacheName)
                {
                    // Return true if you want to remove this cache,
                    // but remember that caches are shared across
                    // the whole origin
                }).map(function (cacheName)
                {
                    return caches.delete(cacheName);
                })
            );
        })
    );
});

// fetching cache
self.addEventListener("fetch", function (event)
{
    /* We should only cache GET requests, and deal with the rest of method in the
        client-side, by handling failed POST,PUT,PATCH,etc. requests.
    */
    if (event.request.method !== 'GET' ||
        event.request.url.includes('/umbraco#/') ||
        event.request.url.includes('/umbraco/') ||
        event.request.url.includes('/App_Plugins/')
    )
    {
        /* If we don't block the event as shown below, then the request will go to
            the network as usual.
        */
        return;
    }
    /* Similar to event.waitUntil in that it blocks the fetch event on a promise.
        Fulfillment result will be used as the response, and rejection will end in a
        HTTP response indicating failure.
    */
    event.respondWith(
        caches
            /* This method returns a promise that resolves to a cache entry matching
                the request. Once the promise is settled, we can then provide a response
                to the fetch request.
            */
            .match(event.request)
            .then(function (cached)
            {
                /* Even if the response is in our cache, we go to the network as well.
                    This pattern is known for producing "eventually fresh" responses,
                    where we return cached responses immediately, and meanwhile pull
                    a network response and store that in the cache.
                    Read more:
                    https://ponyfoo.com/articles/progressive-networking-serviceworker
                */
                var networked = fetch(event.request)
                    // We handle the network request with success and failure scenarios.
                    .then(fetchedFromNetwork, unableToResolve)
                    // We should catch errors on the fetchedFromNetwork handler as well.
                    .catch(unableToResolve);

                /* We return the cached response immediately if there is one, and fall
                    back to waiting on the network as usual.
                */

                return networked || cached;

                function fetchedFromNetwork(response)
                {
                    /* We copy the response before replying to the network request.
                        This is the response that will be stored on the ServiceWorker cache.
                    */
                    var cacheCopy = response.clone();

                    caches
                        // We open a cache to store the response for this request.
                        .open(_cacheName)
                        .then(function add(cache)
                        {
                            /* We store the response for this request. It'll later become
                                available to caches.match(event.request) calls, when looking
                                for cached responses.
                            */
                            cache.put(event.request, cacheCopy);
                        })
                        .then(function ()
                        {
                            //console.log('WORKER: fetch response stored in cache.', event.request.url);
                        });

                    // Return the response so that the promise is settled in fulfillment.
                    return response;
                }

                /* When this method is called, it means we were unable to produce a response
                    from either the cache or the network. This is our opportunity to produce
                    a meaningful response even when all else fails. It's the last chance, so
                    you probably want to display a "Service Unavailable" view or a generic
                    error response.
                */
                function unableToResolve()
                {
                    /* There's a couple of things we can do here.
                        - Test the Accept header and then return one of the `offlineFundamentals`
                          e.g: `return caches.match('/some/cached/image.png')`
                        - You should also consider the origin. It's easier to decide what
                          "unavailable" means for requests against your origins than for requests
                          against a third party, such as an ad provider
                        - Generate a Response programmaticaly, as shown below, and return that
                    */

                    /* Here we're creating a response programmatically. The first parameter is the
                        response body, and the second one defines the options for the response.
                    */

                    // fallback to cache
                    return caches.match(event.request)
                        .then(function (res)
                        {
                            // fallback to 503 page
                            if (res === undefined)
                            {
                                var _responseBody = `
                                    <div style="width:600px; margin:60px auto 0; text-align:center; font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;color: #444;">
                                        <h1>Pagina non disponibile</h1>
                                        <h2>Controlla la tua connessione internet</h2>
                                        <div style="margin:30px auto; text-align:center;">
                                            <img src="/assets/shared/img/offline.gif" alt="offline" />
                                        </div>
                                    </div>
                                `;

                                return new Response(
                                    _responseBody,
                                    {
                                        status: 503,
                                        statusText: 'Service Unavailable',
                                        headers: new Headers({
                                            'Content-Type': 'text/html'
                                        })
                                    });
                            }
                            return res;
                        })


                }
            })
    );
});

// message (eg: updating sw)
self.addEventListener('message', function (event)
{
    if (event.data.action === 'skipWaiting')
    {
        self.skipWaiting();
    }
});